import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { Camera } from '../types';
import { CameraSettingsPanel } from './CameraSettingsPanel';
import { useLanguage } from '../i18n/LanguageContext';

interface Props {
  camera: Camera | null;
  gatewayUrl: string;
  recordDuration: number;
  onRecordDurationChange: (val: number) => void;
  open: boolean;
  onClose: () => void;
  onUpdate: (camera: Camera) => void;
}

export const CameraSettingsDialog: React.FC<Props> = ({
  camera,
  gatewayUrl,
  recordDuration,
  onRecordDurationChange,
  open,
  onClose,
  onUpdate,
}) => {
  const { t } = useLanguage();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 1.5 }}>
        <span>{camera?.name} — {t.cameraSettings}</span>
        <IconButton size="small" aria-label={t.a11yClose} onClick={onClose}><Close fontSize="small" /></IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {camera && (
          <CameraSettingsPanel
            camera={camera}
            gatewayUrl={gatewayUrl}
            recordDuration={recordDuration}
            onRecordDurationChange={onRecordDurationChange}
            onUpdate={onUpdate}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" size="small">
          {t.alarmAuthConfirm}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
